import * as React from 'react'

export default class Dizzy extends React.Component {
  static optionValue = 'Dizzy'

  render () {
    const pieceId = 'Eyes/Dizzy-😵'

    return (
      <g id={pieceId}
         stroke='none'
         strokeWidth='1'
         fill='none'
         fillRule='evenodd'>
        <path
          d='M25,27.2 L19.5,32.7 C19.1,33.1 18.4,33.1 17.9,32.7 L16.3,31.1 C15.9,30.7 15.9,30 16.3,29.5 L21.8,24 L16.3,18.5 C15.9,18 15.9,17.3 16.3,16.9 L17.9,15.3 C18.3,14.9 19,14.9 19.5,15.3 L25,20.8 L30.5,15.3 C30.9,14.9 31.6,14.9 32.1,15.3 L33.7,16.9 C34.1,17.3 34.1,18 33.7,18.5 L28.2,24 L33.7,29.5 C34.1,29.9 34.1,30.6 33.7,31.1 L32.1,32.7 C31.7,33.1 31,33.1 30.5,32.7 L25,27.2 Z'
          id='Eye'
          fill='#000000'
          fillRule='nonzero'/>
        <path
          d='M79,27.2 L73.5,32.7 C73.1,33.1 72.4,33.1 71.9,32.7 L70.3,31.1 C69.9,30.7 69.9,30 70.3,29.5 L75.8,24 L70.3,18.5 C69.9,18 69.9,17.3 70.3,16.9 L71.9,15.3 C72.3,14.9 73,14.9 73.5,15.3 L79,20.8 L84.5,15.3 C84.9,14.9 85.6,14.9 86.1,15.3 L87.7,16.9 C88.1,17.3 88.1,18 87.7,18.5 L82.2,24 L87.7,29.5 C88.1,29.9 88.1,30.6 87.7,31.1 L86.1,32.7 C85.7,33.1 85,33.1 84.5,32.7 L79,27.2 Z'
          id='Eye'
          fill='#000000'
          fillRule='nonzero'/>
      </g>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/bottts/bot/eyes/Dizzy.tsx